import {Controller, useFormContext} from "react-hook-form";
import ProcessTextField from "views/ProcessDetails/refactor/components/ProcessTextField";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyageFlightField = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();
  return (
    <Controller
      name={
        `boarding.voyages.${index}.voyageFlight` as `boarding.voyages.0.voyageFlight`
      }
      control={control}
      render={({field: {onChange, value}}) => (
        <ProcessTextField
          name={`boarding.voyages.${index}.voyageFlight`}
          placeholder="Viagem"
          value={value ?? ""}
          onChange={onChange}
          size="small"
          fullWidth
          label="Viagem"
          disabled={disabled}
        />
      )}
    />
  );
};

export default VoyageFlightField;
